"use strict";

exports.__esModule = true;
exports["default"] = Account;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function Account(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 14 18",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("title", null, "Account"), /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0 0h9.333v9.6H0V0z"
  })), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.992 16.56c-.017-.07-.033-.142-.052-.21-.81-2.984-3.409-5.347-6.527-5.53-.136-.007-.274-.02-.413-.02-.14 0-.275.013-.413.02C3.47 11.003.872 13.366.06 16.35c-.02.068-.034.14-.052.21-.094.584.637 1.44 1.4 1.44h11.185c.762 0 1.493-.854 1.4-1.44"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    transform: "translate(2.333)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M4.667 9.6C2.09 9.6 0 7.45 0 4.8S2.09 0 4.667 0s4.6 2.133 4.666 4.8c0 2.65-2.09 4.8-4.666 4.8"
  }))));
}